import { useLayoutContext } from '@context/LayoutContext';
import LinkItem from './LinkItem';
import { getMegamenuEntryLabel } from '@monofront/business/utils';

const HighlightedLinks = () => {
  const { megamenu } = useLayoutContext();

  return (
    <>
      {megamenu.highlightedLinks.map((link) => {
        const label = getMegamenuEntryLabel(link);

        if (!label) {
          return null;
        }

        const href = `/collections/${link.linkedCollection.handle}`;

        return (
          <LinkItem
            key={link.linkedCollection.id}
            highlighted={Boolean(link.labelBackgroundColor)}
            href={href}
            label={label}
            color={link.labelColor ?? undefined}
            handle={link.linkedCollection.handle}
          />
        );
      })}
    </>
  );
};

export default HighlightedLinks;
